import { render, staticRenderFns } from "./MonitorChapterEdit.vue?vue&type=template&id=55854b01&"
import script from "./MonitorChapterEdit.vue?vue&type=script&lang=js&"
export * from "./MonitorChapterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports